import { Medal } from "lucide-react";

/** Awarded to the first review that documents an experience on Vecurate. */
const PioneerBadge = ({ className }: { className?: string }) => (
  <span
    title="Pioneer — first person to document this experience on Vecurate"
    className={`inline-flex items-center gap-1 rounded-full border border-[#C9A227]/40 bg-[#C9A227]/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-[#8A6F13] ${className ?? ""}`}
  >
    <Medal className="w-3 h-3" />
    Pioneer
  </span>
);

export default PioneerBadge;
